export default __webpack_public_path__ + "static/media/X_Icon.1493ea3a.svg";